import "./Headings.scss";

export function PageHeading({ children }: { children: React.ReactNode }) {
  return <div className="page-heading">{children}</div>;
}
